const edadesMenores = [
  { id: "3", text: "3 años" },
  { id: "4", text: "4 años" },
  { id: "5", text: "5 años" },
  { id: "6", text: "6 años" },
  { id: "7", text: "7 años" },
  { id: "8", text: "8 años" },
  { id: "9", text: "9 años" },
  { id: "10", text: "10 años" },
  { id: "11", text: "11 años" },
  { id: "12", text: "12 años" },
  { id: "13", text: "13 años" },
  { id: "14", text: "14 años" },
  { id: "15", text: "15 años" },
  { id: "16", text: "16 años" },
];

export const edadesMenoresMap = edadesMenores.reduce((prev, value) => {
  return {
    ...prev,
    [value.id]: value.text,
  };
}, {});

export { edadesMenores };
